import { useParams as commonUseParams } from "packages/react-router-dom";

// @ts-ignore

export const useParams = <T>(): T => commonUseParams();
